import { render } from "./PreventionBoxFolderInfo.component.vue?vue&type=template&id=2cf255de"
import script from "./PreventionBoxFolderInfo.component.vue?vue&type=script&lang=js"
export * from "./PreventionBoxFolderInfo.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/prevention/preventionBoxes/PreventionBoxFolderInfo.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cf255de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cf255de', __exports__)) {
    console.log('reload')
    api.reload('2cf255de', __exports__)
  }
  
  module.hot.accept("./PreventionBoxFolderInfo.component.vue?vue&type=template&id=2cf255de", () => {
    console.log('re-render')
    api.rerender('2cf255de', render)
  })

}


export default __exports__